import Button from 'common/components/Button/Button';
import PageHeader from 'common/components/PageHeader/PageHeader';
import Table from 'common/components/Table/Table';
import useAuth from 'common/contexts/auth';
import useRouter from 'common/hooks/use-router';
import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import useItem from '../../common/hooks/useItem';
import useList from '../../common/hooks/useList';

const HolidaysTypesList = () => {
  const { t } = useTranslation();
  const {
    fetchItems,
    items,
    isFetching,
    filters,
    setFilter,
    setPageIndex,
    pageIndex,
    pageCount,
    removeListItem,
  } = useList('holidays-types', { defaultFilters: {}, defaultSort: 'name:ASC', cachePrefix: 'holidayTypes' });
  const {
    removeItem,
  } = useItem('holidays-types');
  const { push } = useRouter();
  const { isAdmin } = useAuth();

  const handleDelete = useCallback(async (id) => {
    removeListItem(id);
    await removeItem(id);
    fetchItems();
  }, [removeListItem, fetchItems, removeItem]);

  const columns = useMemo(() => [
    {
      Header: t('common.name'),
      filterName: 'name_contains',
      className: 'table-start',
      Cell: ({
        row: {
          original: {
            id, name, color, icon,
          },
        },
      }) => (
        <>
          <div
            onClick={() => push(`/holidays-types/edit/${id}`)}
            className="icon-picker-circle is-edited crud-item-avatar"
            style={{
              backgroundColor: `${color}`,
            }}
          >
            <i className={`fas fa-${icon}`} />
          </div>

          <span className="clickable" onClick={() => push(`/holidays-types/edit/${id}`)}>{name}</span>
        </>
      ),
    },
    {
      Header: t('common.company'),
      Cell: ({ row: { original: { id, company } } }) => (
        <span className="clickable" onClick={() => push(`/holidays-types/edit/${id}`)}>{company?.name}</span>
      ),
    },
    {
      Header: t('contractType.hasBalance'),
      Cell: ({ row: { original: { has_balance: hasBalance } } }) => (
        <span>{hasBalance ? t('common.yes') : t('common.no')}</span>
      ),
    },
    {
      Header: t('common.actions'),
      className: 'table-actions',
      // eslint-disable-next-line
      Cell: ({ row: { original: { id } } }) => {
        if (!isAdmin) return null;

        return (
          <>
            <Button
              onClick={() => push(`/holidays-types/edit/${id}`)}
              icon="fa-pencil-alt"
              color="primary"
              transparent
            />
            <Button
              // eslint-disable-next-line react/prop-types
              onClick={() => handleDelete(id)}
              icon="fa-trash-alt"
              color="danger"
              confirm
              transparent
              confirmMessage={t('common.delete')}
            />
          </>
        );
      },
    },
  ], [t, push, handleDelete, isAdmin]);

  return (
    <>
      <PageHeader
        title={t('common.holidaysTypes')}
        link={{ url: '/holidays-types/add', icon: 'plus', label: t('common.add') }}
        subLink={{
          url: '/configure',
          icon: 'arrow-left',
          goBack: true,
          label: t('common.back'),
        }}
      />
      <section className="section list-page list-action">
        <Table
          data={items ?? []}
          columns={columns}
          isFetching={isFetching}
          pageCount={pageCount}
          filters={filters}
          setFilter={setFilter}
          setPageIndex={setPageIndex}
          pageIndex={pageIndex}
        />
      </section>
    </>
  );
};

export default HolidaysTypesList;
